import { USE_KINETIK_AI_CALL_CENTER_EXTERNAL_ORIGIN_FLAG } from '../feature-flagging';

// See src/lib/constants/supportedExternalOrigins.js in kinetik-trip-service
export const SUPPORTED_EXTERNAL_ORIGINS = Object.freeze({
  KINETIK_MA: Object.freeze({
    name: 'Kinetik Health App',
    logicalIdentifier: 'kinetik.memberApp',
  }),
  AI_CALLCENTER: Object.freeze({
    name: 'AI Call Center',
    logicalIdentifier: 'kinetik.aiCallCenter',
    featureFlag: USE_KINETIK_AI_CALL_CENTER_EXTERNAL_ORIGIN_FLAG,
  }),
});
